import styled from 'styled-components'

import { ClinTheme } from '../../../ClinTheme'

export type PatientInitialsAvatarSize = 'sm' | 'md'

interface IStyledInitialsProps {
  background?: string
  blur?: boolean
  size?: PatientInitialsAvatarSize
}

const sizeConfig = {
  sm: {
    circle: 28,
    fontSize: ClinTheme.fontSizes[0],
    lineHeight: ClinTheme.lineHeights.largeParagraph
  },
  md: {
    circle: 34,
    fontSize: 15,
    lineHeight: '16px'
  }
} as const

function getSize(size: PatientInitialsAvatarSize = 'sm') {
  return sizeConfig[size]
}

export const StyledPatientInitialsAvatarCircle =
  styled.div<IStyledInitialsProps>(
    ({ size = 'sm' }: IStyledInitialsProps) => {
      const config = getSize(size)
      return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        color: ClinTheme.colors.primary,
        fontSize: config.fontSize,
        textTransform: 'uppercase',
        height: config.circle,
        width: config.circle,
        minWidth: config.circle,
        margin: 2,
        fontWeight: ClinTheme.fontWeights.medium,
        textAlign: 'center',
        lineHeight: config.lineHeight,
        marginRight: ClinTheme.space[3]
      }
    },
    ({ background, blur }: IStyledInitialsProps) => ({
      backgroundColor: background ? background : ClinTheme.colors.primaryLight,
      filter: blur ? 'blur(3.5px)' : ''
    })
  )
